import { createSelector } from 'reselect';

const getQualities = ({ myself: { qualities = [] } }) => qualities;

const inputFuncs = [getQualities];

const outputFunc = (qualities) => {
  // Build a map of possession and equippable IDs to their quantity
  const reduceFn = (acc, item) => ({ ...acc, [item.id]: item.level });
  return qualities.reduce(reduceFn, {});
};

export default createSelector(inputFuncs, outputFunc);